var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"control"},[_c('input',{staticClass:"input",attrs:{"name":_vm.config.name ? _vm.config.name : _vm.config.label,"required":_vm.config.required,"type":_vm.config.type,"placeholder":(_vm.config.placeholder ? _vm.config.placeholder : _vm.config.label) + (_vm.config.required ? ' (*)' : '')}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e41a3238","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/blocks/modules/formfields/Input.vue
// module id = null
// module chunks = 